( function( app ) {
  const COMPONENT = {
    init: function() {
      const isMobile = function() {
        return window.innerWidth < 1024;
      };

      // On mobile there is no expand/collapse: block the toggle-state
      // library from ever seeing the click and open a lightbox instead.
      document.addEventListener( 'click', function( event ) {
        const trigger = event.target.closest( '.painting-highlight__trigger' );
        if ( !trigger || !isMobile() ) return;

        event.preventDefault();
        event.stopPropagation();

        const src = trigger.getAttribute( 'data-lightbox-src' );
        if ( !src ) return;

        $.magnificPopup.open( {
          items: {
            src: src,
          },
          type: 'image',
        } );
      }, true );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'painting-highlight', COMPONENT );
} )( app );
